import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { MyContext } from '../MyContext';

const PrivateRoute = ({ children }) => {
    const { isAuthenticated } = useContext(MyContext);
    return isAuthenticated ? children : <Navigate to="/" replace />;
};

export default PrivateRoute;